/**
 * @name getGeneralImage - Method for filtering array of images from strapi
 * @param {Array} generalImageArray - array of object from strapi
 * @param {String} key - key of the image needs to be fetched, can be found in strapi component
 * @param {String} view - pass the view of that image e.g if you need mobileview image then pass 'MobileView' return should be like object of url and alternative text of that image
 * @returns {Object} - returns the object of response
 */

const getGeneralImage = ({ generalImageArray, key, view }) => {
  let imagePath = { url: '', alt: '' };
  const tempArray = generalImageArray?.filter(obj => obj.Key === key);
  if (tempArray?.length > 0) {
    if (view === 'DesktopViewImage') {
      imagePath = {
        url: tempArray[0]?.DesktopViewImage?.data?.attributes?.url,
        alt: tempArray[0]?.DesktopViewImage?.data?.attributes?.alternativeText,
      };
    } else if (view === 'MobileViewImage') {
      imagePath = {
        url: tempArray[0]?.MobileViewImage?.data?.attributes?.url,
        alt: tempArray[0]?.MobileViewImage?.data?.attributes?.alternativeText,
      };
    } else if (view === 'TabletViewImage') {
      imagePath = {
        url: tempArray[0]?.TabletViewImage?.data?.attributes?.url,
        alt: tempArray[0]?.TabletViewImage?.data?.attributes?.alternativeText,
      };
    }
  }
  return imagePath;
};

export default getGeneralImage;
